import ReactSlider from 'react-slider';
import './Slider.scss';

type Props = {
    onChange?: (value: number) => void;
    defaultValue?: number;
    min?: number;
    max?: number;
    step?: number;
};

const Slider = ({ onChange, defaultValue, min = 1, max = 10, step = 0.01 }: Props) => {
    return (
        <ReactSlider
            className="horizontal-slider"
            thumbClassName="slider-thumb"
            trackClassName="slider-track"
            onChange={onChange}
            defaultValue={defaultValue}
            min={min}
            max={max}
            step={step}
        />
    );
};

export default Slider;
